module.exports = __webpack_public_path__ + "static/daniel-curtis-52af66550047d3a7dcec4a8e4f9ea04d.jpg";